import { classNames } from "../../../tool";
import { useSetState } from "ahooks";
import ActionSheet from "../../../components/actionSheet";
import styles from "./index.module.scss";
import { useEffect } from "react";

export default function FilterModal(props) {
  const { visible, onClose, value, onConfirm } = props;
  const [state, setState] = useSetState({
    date: value[1],
    status: value[0],
  });
  const { date, status } = state;
  useEffect(() => {
    if (visible) {
      setState({
        date: value[1],
        status: value[0],
      });
    }
  }, [visible]);
  const dateList = [
    { label: "全部", value: "" },
    { label: "今天", value: "0" },
    { label: "昨天", value: "1" },
    { label: "近7日", value: "6" },
    { label: "近15日", value: "14" },
    { label: "近30日", value: "29" },
  ];
  const stateList = [
    { label: "待结算", value: 0 },
    { label: "已结算", value: 1 },
  ];
  return (
    <ActionSheet
      visible={visible}
      close={onClose}
      className={styles.dateAction}
    >
      <div className={styles.datePicker}>
        <div className={styles.title}>
          <span className={styles.clsoe} onClick={onClose}>
            取消
          </span>
        </div>
        <div className={styles.content}>
          <div className={styles.label}>状态选择</div>
          <div className={styles.list}>
            {stateList.map((item, index) => {
              return (
                <div
                  key={index}
                  className={classNames(
                    styles.item,
                    item.value === status ? styles.active : ""
                  )}
                  onClick={() => {
                    setState({
                      status: item.value,
                    });
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.label}>时间选择</div>
          <div className={styles.list}>
            {dateList.map((item, index) => {
              return (
                <div
                  key={index}
                  className={classNames(
                    styles.item,
                    item.value === date ? styles.active : ""
                  )}
                  onClick={() => {
                    setState({
                      date: item.value,
                    });
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.footer}>
          <div
            className={classNames(styles.btn, styles.confirm)}
            onClick={() => {
              onConfirm([status, date]);
              onClose();
            }}
          >
            确定
          </div>
        </div>
      </div>
    </ActionSheet>
  );
}
